"use client";

import type { ReactNode } from "react";
import { cn } from "../../utils";

// Spelled out, not ComponentProps<"button">: this sometimes renders a <div> (nesting buttons is invalid).
export type ControlProps = {
  className?: string;
  onClick?: () => void;
  "aria-label"?: string;
  "data-testid"?: string;
};

type Props = ControlProps & {
  as?: "button" | "div";
  children: ReactNode;
  noClickable?: boolean;
};

export function ControlContainer({
  as = "button",
  children,
  className,
  noClickable = false,
  ...props
}: Props) {
  const classes = cn(
    "bg-card rounded-full",
    "size-10 flex flex-col justify-center items-center",
    "shrink-0",
    "outline-none focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50",
    !noClickable &&
      "hover:cursor-pointer transform hover:scale-105 transition-all ease-in-out focus:scale-95",
    className,
  );

  if (as === "div") {
    return (
      <div className={classes} {...props}>
        {children}
      </div>
    );
  }

  return (
    <button type="button" className={classes} {...props}>
      {children}
    </button>
  );
}
